/*
 * Spinder Design — PDP-gedrag.
 * 1. Media-gallery: thumbnail-klik wisselt het hoofdbeeld.
 * 2. Sticky mobiele koopbalk: verschijnt zodra de hoofd-koopknop uit beeld is,
 *    en de knop triggert de echte Dawn add-to-cart (productformulier submit).
 * De cart-/variant-logica zelf draait via Dawn (product-info.js / product-form.js).
 */
(function () {
  'use strict';

  function initRoot(root) {
    initGallery(root);
    initStickyBar(root);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-spinder-gallery]');
    if (!gallery) return;

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-spinder-thumb]'));
    var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-spinder-stage-item]'));
    if (!items.length) return;

    /* Volgorde van media (= productvolgorde) op basis van de stage-items. */
    var order = items.map(function (item) { return item.getAttribute('data-media-id'); });
    function indexOf(mediaId) { return order.indexOf(String(mediaId)); }

    /* Blok-grenzen: de index van elke variant-hoofdfoto markeert het begin van
       een kleurblok. De foto's van één kleur staan aaneengesloten tot de
       volgende grens. Komt uit data-spinder-variant-fm (door Liquid gevuld). */
    /* Variant-id → getoonde media-id (Liquid: data-spinder-variant-media). Wijst
       naar het origineel als de variantfoto een verborgen duplicaat is, of naar
       de eerste foto met de SKU als de variant zelf geen foto heeft. */
    var mediaByVariant = {};
    (gallery.getAttribute('data-spinder-variant-media') || '').split(',').forEach(function (pair) {
      var p = pair.split(':');
      if (p.length === 2 && p[0].trim() && p[1].trim()) mediaByVariant[p[0].trim()] = p[1].trim();
    });

    var boundaries = [];
    (gallery.getAttribute('data-spinder-variant-fm') || '').split(',').forEach(function (idStr) {
      var id = idStr.trim();
      if (!id) return;
      var idx = indexOf(id);
      if (idx >= 0 && boundaries.indexOf(idx) === -1) boundaries.push(idx);
    });
    boundaries.sort(function (a, b) { return a - b; });
    var canGroup = boundaries.length >= 2; /* alleen filteren bij meerdere kleuren */

    /* Per variant-id de media-id van de sfeerfoto (Liquid: data-spinder-variant-sfeer,
       gevuld uit variant-metafield specs.sfeer_image). Bij een kleurwissel springen
       we hiernaartoe i.p.v. de packshot. Leeg → gewoon de hoofdfoto. */
    var sfeerByVariant = {};
    (gallery.getAttribute('data-spinder-variant-sfeer') || '').split(',').forEach(function (pair) {
      var p = pair.split(':');
      if (p.length === 2 && p[0].trim() && p[1].trim()) sfeerByVariant[p[0].trim()] = p[1].trim();
    });

    function blockRange(idx) {
      var start = 0;
      for (var i = 0; i < boundaries.length; i++) {
        if (boundaries[i] <= idx) start = boundaries[i]; else break;
      }
      var end = order.length;
      for (var j = 0; j < boundaries.length; j++) {
        if (boundaries[j] > start) { end = boundaries[j]; break; }
      }
      return [start, end];
    }

    function activate(mediaId) {
      items.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === mediaId);
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-spinder-thumb') === mediaId);
      });
    }

    /* Toon alleen de thumbnails (en stage-items) van het kleurblok waar mediaId in valt. */
    function filterToBlock(mediaId) {
      if (!canGroup) return;
      var idx = indexOf(mediaId);
      if (idx < 0) return;
      var r = blockRange(idx), start = r[0], end = r[1];
      thumbs.forEach(function (thumb) {
        var k = order.indexOf(thumb.getAttribute('data-spinder-thumb'));
        var inBlock = k >= start && k < end;
        /* Verberg de <li>-wrapper (flex-child), niet alleen de knop — anders
           blijft de flex-gap van lege items het blok naar rechts duwen. */
        var cell = thumb.closest('.spinder-pdp__thumb-item') || thumb;
        cell.style.display = inBlock ? '' : 'none';
      });
      items.forEach(function (item, k) { item.style.display = (k >= start && k < end) ? '' : 'none'; });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(thumb.getAttribute('data-spinder-thumb'));
      });
    });

    /* Beginstaat: filter direct op de huidige (actieve) variant-foto. */
    var initialActive = items.filter(function (it) { return it.classList.contains('is-active'); })[0];
    if (initialActive) filterToBlock(initialActive.getAttribute('data-media-id'));

    /* Variant-wissel: spring naar de hoofdfoto van die kleur én toon alleen
       de foto's van die kleur. Dawn publiceert hiervoor 'variant-change'. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data ? event.data.variant : null;
        if (!variant) return;
        var fmId = mediaByVariant[String(variant.id)]
          || (variant.featured_media && variant.featured_media.id != null ? String(variant.featured_media.id) : null);
        if (!fmId) return;
        if (indexOf(fmId) < 0) return;
        /* Blok bepalen op de hoofdfoto; als groot beeld tonen we de sfeerfoto
           van deze kleur (indien aanwezig en in beeld), anders de hoofdfoto. */
        filterToBlock(fmId);
        var sfeerId = sfeerByVariant[String(variant.id)];
        var mediaId = (sfeerId && indexOf(sfeerId) >= 0) ? sfeerId : fmId;
        activate(mediaId);
        /* Sticky koopbalk: foto meewisselen met de gekozen kleur. De bron is
           het al getoonde hoofdbeeld, dus dit kost geen extra download. */
        var stickyImg = root.querySelector('.spinder-pdp__sticky-img');
        if (stickyImg) {
          var stageImg = gallery.querySelector('[data-spinder-stage-item][data-media-id="' + mediaId + '"] img');
          if (stageImg && (stageImg.currentSrc || stageImg.src)) {
            stickyImg.src = stageImg.currentSrc || stageImg.src;
            stickyImg.removeAttribute('srcset');
          }
        }
      });
    }
  }

  /* ---------- Sticky mobiele koopbalk ---------- */
  function initStickyBar(root) {
    var sticky = root.querySelector('[data-spinder-sticky]');
    var buyZone = root.querySelector('[data-spinder-buy]');
    if (!sticky || !buyZone) return;

    var addBtn = sticky.querySelector('[data-spinder-sticky-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var submit = buyZone.querySelector('[type="submit"], button[name="add"]');
        if (submit && !submit.disabled) {
          submit.click();
        }
      });
    }

    function setVisible(visible) {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            /* Toon de balk wanneer de echte koopknop NIET in beeld is. */
            setVisible(!entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0 }
      );
      observer.observe(buyZone);
    }
  }

  function init() {
    document.querySelectorAll('.spinder-pdp').forEach(initRoot);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* Theme-editor: opnieuw initialiseren bij sectie-herlaad. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.spinder-pdp');
    if (root) initRoot(root);
  });
})();
